// extracted by mini-css-extract-plugin
export default {"cardLink":"LinkCard_cardLink__ICwza","stretch":"LinkCard_stretch__NW80N"};